import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { useQuery } from '@tanstack/react-query';
import { ShipmentStatusMappingAdapter } from '../adapters/shipmentStatusMappingAdapter';

export const useCouriers = () => {
  const httpClient = createHttpClient(apiClientWH);
  const adapter = new ShipmentStatusMappingAdapter(httpClient);

  const {
    data: couriers = [],
    isLoading,
    error,
  } = useQuery({
    queryKey: ['couriers'],
    queryFn: () => adapter.fetchCouriers(),
    staleTime: 10 * 60 * 1000,
    gcTime: 15 * 60 * 1000,
  });

  return {
    couriers,
    isLoading,
    error,
  };
};
